export enum enumRoomType {
    'DBL' = 'DBL',
    'SGL' = 'SGL',
    'TRP' = 'TRP',
    'QUD' = 'QUD',
  }